import React from 'react'
import Layout from '../components/layout'
import Article from '../components/article'

export default () => (
  <Layout>
    <Article title="1. Desio">
      <p>Ogni contesto di discussione deve riguardare Desio, direttamente o indirettamente.</p>
    </Article>

    <Article title="2. No pubblicità e spam">
      <p>
        La pubblicità di attività commerciali non è ammessa.<br />
        Ogni eccezione verrà valutata indipendentemente.
      </p>
    </Article>

    <Article title="3. Niente razzismo">
      <p>
        Non è ammessa alcuna discriminazione basata su:
        <ul>
          <li>lingua parlata</li>
          <li>paese di nascita</li>
          <li>credo religioso</li>
          <li>colore della pelle</li>
          <li>sesso</li>
          <li>credo politico</li>
        </ul>
      </p>
    </Article>

    <Article title="4. Critica costruttiva">
      <p>
        Nessuno è perfetto.<br />
        Va bene essere convinti della propria idea, fino a prova contraria.<br />
        Solo lo stupido pensa di non poter mai cambiare idea.
      </p>
    </Article>

    <Article title="5. Sì al confronto politico">
      <p>Il confronto su temi politici è incoraggiato a patto che si basi su considerazioni oggettive e fattuali.</p>
      <p>La becera tifoseria politica verrà sonoramente respinta.</p>
    </Article>
  </Layout>
)
